import { LogLevel, StsConfigHttpLoader } from 'angular-auth-oidc-client';
import { of } from 'rxjs';
import { AppSettingsService } from '@capital-access/common/settings';
import { Settings } from './oidc-settings.model';
import { ImpersonationConfigService } from '@capital-access/common/user';

const getUrl = (route: string) => `${location.origin}${route}`;

export function configLoaderFactory(settingsService: AppSettingsService) {
  const settings = settingsService.getSettings<Settings>().oidc;

  if (!settings) {
    throw new Error(`Can not configure authentication. Oidc settings are not initialized.`);
  }

  const isImpersonating = ImpersonationConfigService.isImpersonating(settings.clientId);
  const scope = isImpersonating ? ImpersonationConfigService.mergeImpersonationScopes(settings.scope) : settings.scope;

  const config = {
    authority: settings.stsServer,
    redirectUrl: getUrl(settings.redirectRoute),
    postLoginRoute: settings.postLoginRoute,
    postLogoutRedirectUri: getUrl(settings.postLogoutRedirectRoute),
    clientId: settings.clientId,
    scope: scope,
    responseType: settings.responseType,
    silentRenew: settings.silentRenew,
    renewTimeBeforeTokenExpiresInSeconds: settings.renewBeforeExpirationInSec,
    disableIatOffsetValidation: settings.disableIatOffsetValidation,
    unauthorizedRoute: settings.unauthorizedRoute,
    logLevel: LogLevel.Error,
    // To avoid redirection after login via pop-up
    triggerAuthorizationResultEvent: true,
    useRefreshToken: settings.useRefreshToken
  };

  return new StsConfigHttpLoader(of(config));
}
